import DeleteTransaksiConfirmModal from './DeleteTransaksiConfirmModal.vue';

export default DeleteTransaksiConfirmModal;
